module.exports = __webpack_public_path__ + "img/loading.ef2a3ec8.gif";